import { ArrowIcon } from "assets/icons";
import { If } from "components";
import { useOnClickOutside } from "hooks";
import { t } from "i18next";
import { useRef } from "react";
import { TableItemActionsModal } from "ui/TableItemActionsModal";

import { StatusControlProps } from "./StatusControl.types";

import styles from "./StatusControl.module.scss";

const StatusControl = ({
  activeStatusIndex,
  statusesList,
  isOpened,
  toggleOpen,
  onClose,
  disabled
}: StatusControlProps) => {
  const optionsRef = useRef(null);
  useOnClickOutside(optionsRef, onClose);

  return (
    <div ref={optionsRef} className={styles.statusControlContainer}>
      <button
        className={styles.activeStatusBtn}
        onClick={toggleOpen}
        disabled={disabled}
        style={{
          backgroundColor: statusesList[activeStatusIndex]?.backgroundColor
        }}
      >
        {t(statusesList[activeStatusIndex]?.label)}
        {!disabled && <ArrowIcon width={18} height={18} />}
      </button>

      <If condition={isOpened}>
        <TableItemActionsModal
          actionsList={statusesList.map((status, index) => ({
            ...status,
            disabled: activeStatusIndex === index
          }))}
          handleClose={() => {}}
          className={styles.statusesListModal}
        />
      </If>
    </div>
  );
};

export default StatusControl;
